"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class WalletServiceLive {
    async createWallet() {
        const response = await HttpProvider_1.httpProvider.post("/wallet");
        return response.data;
    }
    async registerPayId(walletId) {
        const response = await HttpProvider_1.httpProvider.post(`/wallet/${walletId}/register-pay-id`);
        return response.data;
    }
    async getWallet(walletId) {
        const response = await HttpProvider_1.httpProvider.get(`/wallet/${walletId}`);
        return response.data;
    }
    async linkExternalBankAccount(walletId, bankAccount) {
        const response = await HttpProvider_1.httpProvider.post(`/wallet/${walletId}/link-external-bank-account`, bankAccount);
        return response.data;
    }
    async deleteBankAccount(walletId, bankAccount) {
        const response = await HttpProvider_1.httpProvider.post(`/wallet/${walletId}/delete-bank-account`, bankAccount);
        return response.data;
    }
    async withdraw(walletId, withdrawBody) {
        const response = await HttpProvider_1.httpProvider.post(`/wallet/${walletId}/withdraw`, withdrawBody);
        return response.data;
    }
    async completeExternalBankAccountVerification(walletId, verification) {
        const response = await HttpProvider_1.httpProvider.post(`/wallet/${walletId}/complete-external-bank-account-verification`, verification);
        return response.data;
    }
    async getWalletTransactions(walletId, sortBy, sortOrder, page, rowsPerPage) {
        const response = await HttpProvider_1.httpProvider.post(`/wallet/${walletId}/transactions`, {
            sortBy,
            sortOrder,
            page,
            rowsPerPage,
        });
        return response.data;
    }
}
exports.WalletServiceLive = WalletServiceLive;
//# sourceMappingURL=WalletServiceLive.js.map